<template>
  <div class="sc-header">
    <div class="logo" :style="{'width': isCollapse?'64px':'200px'}">
      <span v-show="!isCollapse" class="big">{{ siteName }}</span>
      <span v-show="isCollapse" class="min">{{ shortSiteName }}</span>
    </div>
    <hamburger class="hamburger-container" :is-vertical="true" @click.native="toggleClick"></hamburger>
    <div class="right">
      <!-- <span class="header-btn">
        <el-badge :value="3">
            <i class="el-icon-bell"></i>
        </el-badge>
      </span> -->
      <el-dropdown>
        <span class="header-btn">
            {{ userInfo.user_info.role_name }}&nbsp;{{ userInfo.user_info.username }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="initChangePassword">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" size="tiny" :visible.sync="isShowCP">
        <el-form label-position="right" label-width="100px" :model="user" :rules="rules" ref="userForm">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input type="password" v-model="user.oldPassword"  placeholder="输入旧密码" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password"  v-model="user.password"  placeholder="输入新密码" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input type="password"  v-model="user.confirmPassword"  placeholder="输入新密码" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelHandle">取消</el-button>
          <el-button type="primary" @click="confirmHandle">提交</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script type="text/babel">
import constants from 'config/constants'
import Hamburger from 'components/Hamburger'
import { mapState } from 'vuex'
import UserModel from 'models/user'

export default {
  name: 'KyHeader',
  components: {
    Hamburger
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var validConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.user.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      siteName: constants.basic.siteName,
      shortSiteName: constants.basic.shortSiteName,
      isShowCP: false,
      user: {oldPassword: '', password: '', confirmPassword: ''},
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码至少要6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validConfirmPassword, trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info,
    }),
  },
  methods: {
    toggleClick () {
      this.$emit('toggleClick')
    },
    logout () {
      this.$router.push({
        name: 'login'
      })
    },
    cancelHandle () {
      this.$refs.userForm.resetFields()
      this.isShowCP = false
    },
    confirmHandle () {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const opts = {
            oldPassword: this.user.oldPassword,
            password: this.user.password,
          }
          UserModel.changePassword(opts).then(() => {
            this.$message({ message: '修改密码成功，请重新登录', type: 'success' })
            this.isShowCP = false
            this.$router.push({
              name: 'login'
            })
          }).catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
          return true
        }
        return false
      })
    },
    initChangePassword () {
      this.isShowCP = true
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.sc-header
  background-color: #242f42
  height: 100%
  .logo
    float: left
    height: 50px
    font-size: 20px
    font-weight: 500
    letter-spacing: 1px
    text-align: center
    line-height: 50px
    color: #ffffff
    border-right: 1px solid #324157
    background-color: #242f42
  .hamburger-container
    line-height: 58px
    height: 50px
    float: left
    padding: 0 10px
    fill: #fff
  .right
    float: right
    .header-btn
      overflow: hidden
      height: 50px
      display: inline-block
      text-align: center
      line-height: 50px
      cursor: pointer
      padding: 0 14px
      color: #fff
      &:hover
        background-color: #367fa9
      .el-badge__content
        top: 14px
        right: 7px
        text-align: center
        font-size: 9px
        padding: 0 3px
        background-color: #00a65a
        color: #fff
        border: none
        white-space: nowrap
        vertical-align: baseline
        border-radius: .25em

</style>



// WEBPACK FOOTER //
// src/components/KyHeader.vue